<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <resize-observer @notify="__resizeHanlder" />
  <span slot="title" class="dialog-header">
    <span  class="title" >{{$t('customer_portal.Bill_payment_title')}}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-steps :active="step" align-center finish-status="success">
        <el-step>
          <template slot="title">
            <span class="hidden-sm-and-down">{{$t('customer_portal.Bill_payment_step0_title')}}</span>
          </template>
        </el-step>
        <el-step>
          <template slot="title">
            <span class="hidden-sm-and-down">{{$t('customer_portal.Bill_payment_step1_title')}}</span>
          </template>
        </el-step>
        <el-step>
          <template slot="title">
            <span class="hidden-sm-and-down">{{$t('customer_portal.Bill_payment_step2_title')}}</span>
          </template>
        </el-step>
        <el-step>
          <template slot="title">
            <span class="hidden-sm-and-down">{{$t('customer_portal.Bill_payment_step3_title')}}</span>
          </template>
        </el-step>
      </el-steps>
      <div v-if="step==0">
        <el-form ref="invoicesForms" style="margin-top:60px;">
          <el-row type="flex" justify="center">
            <el-col style="max-width:600px;text-align:center;;">
                <p style="word-break:break-word">{{$t('customer_portal.Payment_instructions')}}</p>
                <br>
                <p style="word-break:break-word"><i class="el-icon-warning-outline"></i> {{$t('customer_portal.Payment_warning')}}</p>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px;" type="flex" justify="center">
            <el-col style="max-width:800px;">
              <el-table
                :data="invoices"
                style="width:100%;"
                v-if="pageWidth>=1024">

                <el-table-column
                  prop="invNumber"
                  label="Numéro de facture">
                </el-table-column>
                <el-table-column
                  prop="total"
                  label="Total"
                  align="right">
                  <template slot-scope="scope">
                    {{$n(scope.row.total, 'currency', currency)}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Montant payé"
                  align="right">
                  <template slot-scope="scope">
                    {{$n(getAmountPaid(scope.row), 'currency', currency)}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Montant à payer"
                  align="right">
                  <template slot-scope="scope">
                    {{$n(calculateAmountDueOnInvoice(scope.row), 'currency', currency)}}
                  </template>
                </el-table-column>
              </el-table>
              <div v-else>
                <el-card shadow="hover" v-for="invoice in invoices" :key="invoice.id" style="color:#4a596a;margin-bottom:10px;">
                    <div style="display:block;float:left;margin-bottom:20px;">
                      <strong>{{invoice.invNumber}}</strong><br>
                      <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Date_of_issue_colon')}} {{_moment(invoice.date)}}</span><br>
                      <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Due_date_colon')}} {{_moment(invoice.due_date)}}</span><br>
                      <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Total_amount_colon')}}  {{$n(invoice.total,'currency', currency)}}</span>
                      <span class="hidden-md-and-up fs-14 secondary-text"><br>{{$t('customer_portal.Invoice_Amount_due_colon')}} {{$n(calculateAmountDueOnInvoice(invoice),'currency', currency)}}</span>
                    </div>
                    <div class="hidden-sm-and-down fs-14 secondary-text" style="float:right">
                      <span>{{$t('customer_portal.Invoice_Amount_due')}}</span><br>{{$n(calculateAmountDueOnInvoice(invoice),'currency', currency)}}
                    </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px;" type="flex" justify="end">
            <el-col style="max-width:160px;margin-right:40px;">
              <span><strong> {{$t('customer_portal.Invoice_Total_due_colon')}} </strong> {{$n(amountDue,'currency', currency)}}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top:40px;">
            <el-col>
                <el-form-item style="text-align:center;">
                  <span><strong>{{$t('customer_portal.Payment_amount_colon')}} </strong></span><el-input-number v-model="amount" :precision="2" :step="0.1" :max="amountDue" size="small"></el-input-number>
                </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- CREDIT CARD FORM STARTS HERE -->
      <div class="panel panel-default credit-card-box" v-show="step==1" style="margin-top:60px;">
        <el-form>
          <el-row v-if="errorMessage">
              <el-col>
                <el-alert title="Erreur lors de la confirmation de paiement" type="error">{{errorMessage}}</el-alert>
                <!-- errorMessage -->
              </el-col>
          </el-row>
           <p style="text-align:center;">{{$t('customer_portal.Payment_information_instructions')}}</p>
            <el-row style="margin-top:20px;" type="flex" justify="center">
              <el-col  style="max-width:600px;">

                <el-card shadow="never">
                  <form ref="stripeForm" role="stripe" id="payment-form" method="POST" action="javascript:void(0);">
                   

                    <!-- STRIPE ELEMENTS -->
                    <div style="margin-top: 20px" v-if="paymentMethods.length > 0">
                      <span>{{$t('customer_portal.cardSelectOption')}}</span>
                    <el-radio-group v-model="paymentMethod" style="width:100%;" @change="handleSelectCard">
                      <el-radio v-for="pm in paymentMethods" :key="pm.id"  :label="pm.id" border class="m-10">
                        <paymentCardInfo :brand="pm.card.brand" :last4="pm.card.last4" />
                        <el-link style="float:right;" @click="handleCardDeletion(pm)">{{$t('customer_portal.removeCard')}}</el-link>
                      </el-radio>
                      <el-radio :label="-1" border class="m-20"><span class="card_method_number">{{ $t('customer_portal.newCardOption') }}</span></el-radio>
                    </el-radio-group>
                  </div>
                    <div v-show="paymentMethod === -1" class="border p-10" v-loading="paymentFormInitialized === false">
                      <el-form-item :label="$t('customer_portal.cardHolderName')">
                        <el-input v-model="cardHolderName" type="text"></el-input>
                      </el-form-item>
                      
                      <div class="stripe" id="stripe-form">
                        <div class="row">
                          <div class="field">
                            <div id="card-element" class="input empty"></div>
                            <label for="example2-card-number" data-tid="elements_examples.form.card_number_label">{{ $t('customer_portal.cardNumber') }}</label>
                            <div class="baseline"></div>
                          </div>
                        </div>

                        <div id="card-errors" role="alert"></div>

                      </div>
                      <el-checkbox class="m-10 mt-20" v-model="isSavingCard" :label="$t('customer_portal.saveCreditCardOption')" border></el-checkbox>
                      </div>
                  
                  </form>
                </el-card>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- CREDIT CARD FORM ENDS HERE -->
        <div v-if="step==2">
          <el-form ref="invoicesForms" style="margin-top:60px;">

            <el-row>
              <el-col style="text-align:center;">
                  <p style="word-break:break-word;">{{ $t('customer_portal.paymentInstructions') }}</p>
              </el-col>
            </el-row>
            <el-card shadow="never">
            <el-row type="flex" justify="center">
              <el-col style="ma-width:800px;">

                  <h4>{{ $t('customer_portal.Bills_to_pay') }}</h4>
                  <el-table
                    :data="invoices"
                    style="width: 100%;max-width:800px;"
                    v-if="pageWidth>=1024">
                    <el-table-column
                      prop="invNumber"
                      label="Numéro de facture">
                    </el-table-column>
                    <el-table-column
                      prop="total"
                      label="Total"
                      align="right">
                      <template slot-scope="scope">
                        {{$n(scope.row.total, 'currency', currency)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Montant payé"
                      align="right">
                      <template slot-scope="scope">
                        {{$n(getAmountPaid(scope.row), 'currency',currency)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Montant à payer"
                      align="right">
                      <template slot-scope="scope">
                        {{$n(calculateAmountDueOnInvoice(scope.row), 'currency',currency)}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-else>
                    <el-card shadow="hover" v-for="invoice in invoices" :key="invoice.id" style="color:#4a596a;margin-bottom:10px;">
                        <div style="display:block;float:left;margin-bottom:20px;">
                          <strong>{{invoice.invNumber}}</strong><br>
                          <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Date')}} {{_moment(invoice.date)}}</span><br>
                          <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Due_date')}} {{_moment(invoice.due_date)}}</span><br>
                          <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Total_due_colon')}} {{$n(invoice.total,'currency',currency)}}</span>
                          <span class="hidden-md-and-up fs-14 secondary-text"><br>{{$t('customer_portal.Invoice_Amount_due')}} {{$n(calculateAmountDueOnInvoice(invoice),'currency',currency)}}</span>
                        </div>
                        <div class="hidden-sm-and-down fs-14 secondary-text" style="float:right">
                          <span>{{$t('customer_portal.Invoice_Amount_due')}}</span><br>{{$n(calculateAmountDueOnInvoice(invoice),'currency',currency)}}
                        </div>
                    </el-card>
                  </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px;">
              <el-col>
                <span style="float:right;"><strong> Total : </strong> {{$n(amountDue,'currency',currency)}}</span>
              </el-col>
            </el-row>
            </el-card>
            <el-row style="margin-top:40px;">
              <el-col>
                <el-card shadow="never">
                  <span><strong>{{$t('customer_portal.paymentAmount')}} </strong> {{$n(amount,'currency',currency)}}</span>
                </el-card>
              </el-col>
            </el-row>
            <el-row style="margin-top:40px;">
              <el-col>
                  <el-card shadow="never">
                    <h4>{{ $t('customer_portal.paymentInformation') }}</h4>
                    <el-row :gutter="20">
                      <el-col>
                          <paymentCardInfo 
                            :brand="cardBrandInfo"
                            :last4="cardNumberInfo"/>
                      </el-col>
                    </el-row>
                  </el-card>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="step==3">
          <el-row>
            <el-col style="text-align:center;">
              <h3>{{ $t('customer_portal.paymentConfirmedTitle') }}</h3>
              <p style="word-break:break-word;">{{ $t('customer_portal.paymentConfirmedInstruction') }}</p>
            </el-col>
          </el-row>
          <el-row v-if="paymentResponse!=null">
            <el-col>
               <el-card shadow="never">
                 <el-row :gutter="20">
                   <el-col>
                       <span class="fs-14 secondary-text">{{$t('customer_portal.paidAmount')}} {{$n(amount, 'currency', currency)}}  </span>
                   </el-col>
                 </el-row>
                 <el-row :gutter="20">
                   <el-col>
                       <span class="fs-14 secondary-text">{{$t('customer_portal.creditCardMask')}} {{paymentResponse.trx_detail.card.lastDigits}} ({{paymentResponse.trx_detail.card.brand}})  </span>
                   </el-col>
                 </el-row>
                 <el-row :gutter="20">
                   <el-col>
                       <span class="fs-14 secondary-text">{{$t('customer_portal.authorizationCode')}} {{paymentResponse.trx_detail.card.authorization}} </span>
                   </el-col>
                 </el-row>
               </el-card>
            </el-col>
          </el-row>
        </div>
    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="close" v-if="step!=3">{{$t('buttons.Cancel')}}</el-button>
    <el-button @click="previous" :disabled="step==0" v-if="step!=3">{{$t('buttons.Previous')}}</el-button>
    <el-button @click="next" v-if="step<2" :disabled="step==1&&(!complete && (paymentMethod === -1 || paymentMethod == null))">{{$t('buttons.Next')}}</el-button>
    <el-button @click="confirm" v-if="step==2">{{$t('buttons.Confirm')}}</el-button>
    <el-button @click="done" v-if="step==3">{{$t('buttons.Close')}}</el-button>
  </span>
  <waitingDialog :visible="waitingDialogVisible" :title="$t('customer_portal.waitingPaymentTitle')" :content="$t('customer_portal.waitingPaymentInstruction')"></waitingDialog>
  </el-dialog>
</template>
<script>

import paymentAPI from '@/services/API/payment';
import portausCompanyAPI from '@/services/API/portaus-company'
const uuidv1 = require('uuid/v1');
import moment from 'moment-timezone'
import { mapState, mapActions } from 'vuex';
import paymentCardInfo from '@/components/payment-card-info'
import waitingDialog from '@/components/waiting-dialog'

export default {
  name: 'ProcessPaymentModal',
	props: {
		visible : Boolean,
    invoices : Array,
    customerId : Number,
    portausCompanyId: Number,
	},
  data() {
    return {
      waitingDialogVisible: false,
      stripeFormLoading: true,
      paymentMethods: [],
      paymentMethod: null,
      isSavingCard: false,
      fullScreenLoading : false,
      complete : false,
      loading:false,
      pageWidth : 0,
			pageHeight : 0,
      step:0,
      cardHolderName : "",
      cardBrandName : null,
      profile : {
        firstName : null,
        lastName : null,
      },
      billing_details : {
        street : '',
        city : '',
        state : '',
        country : '',
        zip : '',
      },
      amount : 0.00,
      paymentFormInitialized : false,
      card : null,
      cardElement : null,
      cardNumber : null,
      cardExp : null,
      cardCvc : null,
      stripe:null,
      elements : null,
      errorMessage : null,
      timer : '',
      paymentResponse : null,
      stripePK: null,
    };
  },components: {
    paymentCardInfo,
    waitingDialog,
  },
	methods: {
    handleCardDeletion (card) {
      this.paymentMethod= null;
      this.$confirm('Ceci retirera la carte définitivement de la liste des cartes sauvegardées. Continuer?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          return paymentAPI.deletePaymentMethod(card.id)
            .then(() => {
              return this.getPaymentCard(this.customerId)
                .then(() => {
                  this.initializePaymentForm();
                  this.$message({
                    type: 'success',
                    message: 'Carte retirée'
                  });
                })
              
            })
        }).catch((err) => {
          if (err === 'cancel') {
            this.$message({
              type: 'info',
              message: 'Suppression annulée'
            });  
          } else {
            this.$message({
                type: 'error',
                message: 'Une erreur est survenued veuillez réessayer plus tard!'
              });   
          }
                
        });
    },
    handleSelectCard (value) {
      if (value === -1 ) {
        this.initializePaymentForm();
      } 
    },
    unbindPaymentIframe(){
      if(this.cardElement!=null){
        this.cardElement.unmount();
        this.cardElement = null;
      }
    },
    done(){
      this.$emit('paid', this.invoices);
    },
    close(){
      this.$emit('close');
      this.errorMessage = null;
      this.cardHolderName = null;
      this.complete = false;
      this.cardBrandName=null;
      this.cardHolderName=null;
      this.paymentResponse = null;
      this.paymentMethod = -1;
    },
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
    previous(){
      this.step--;

    },
    next(){
      if(this.step === 1){
        this.refNumber=uuidv1();;
        this.step++;
      }else{
        this.step++;
      }

      if (this.step === 1) {
        this.$nextTick(() => {
          this.initializePaymentForm();
          // The whole view is rendered, so I can safely access or query
          // the DOM. ¯\_(ツ)_/¯
        })
        
       
      }
    },
    getPaymentCard (customerId) {
      return paymentAPI.getCustomerPaymentMethods(customerId)
        .then((paymentMethods) => {
          this.paymentMethods = paymentMethods;
          if (_.size(this.paymentMethods) === 0) {
            this.paymentMethod = -1;
          }
        })
    },
    confirm(){
      let _this = this;
      // this.fullScreenLoading=true;
      this.waitingDialogVisible = true;
      let amount = Math.round(this.amount*100)/100;
      const paymentMethod = this.selectedCard != null ? this.selectedCard.id : { card : _this.cardElement,
                billing_details: {
                  name: _this.cardHolderName
                }}
      const postObj = {
        amount,
        currency : _.get(_.head(this.invoices), 'currency'),
        customer: {
          id: this.customerId,
        },
        invoices: _.map(this.invoices, inv => ({id: inv.id, invNumber: inv.invNumber})),
        portausCompanyId: this.portausCompanyId,
        isSavingCard: this.isSavingCard,
      }
      if (_.get(paymentMethod,'id')) {
        postObj.methodPayment = {
          id: _.get(paymentMethod,'id'),
        }
      }
      paymentAPI.createStripePaymentIntent(postObj)
        .then(payment=>{
          let paymentIntent = payment.detail.intentPayment;
          

          _this.stripe.confirmCardPayment(paymentIntent.client_secret, {
              payment_method: paymentMethod,
              setup_future_usage: this.isSavingCard ? "off_session" : undefined,
            }).then(function(result) {
              if (result.error) {
                // Show error to your customer (e.g., insufficient funds)
                // console.log(result.error.message);
                _this.step=1;
                _this.errorMessage = result.error.message;
                _this.fullScreenLoading=false;
              } else {
                // console.log('result payment confirmation : ', result);
                // The payment has been processed!
                if (result.paymentIntent.status === 'succeeded') {
                  // _this.fullScreenLoading=false;
                  // console.log("paymeentIntent.status : ", result);
                  // _this.paymentId = payment.id
                  _this.timer = setInterval(function(){_this.waitingForConfirmation(payment.id)},1000);
                  _this.step++;
                }
              }
            })
        })

    },
    waitingForConfirmation(paymentId){
      paymentAPI.getPayment(paymentId)
        .then(payment=>{
          if(_.get(payment, 'trx_detail.complete') === true){
            this.paymentResponse = payment;
            this.cancelWaitingPayment();
            // this.fullScreenLoading=false;
            this.waitingDialogVisible = false;
          }
        })
    },
    cancelWaitingPayment(){
      clearInterval(this.timer);
    },
    initializePaymentForm(){
      this.paymentFormInitialized=true;
      this.stripe = Stripe(this.stripePK);
      this.elements = this.stripe.elements();
      this.cardElement = null;
      if (this.paymentMethod === -1) {
        var elementStyles = {
          base: {
            color: '#32325D',
            fontWeight: 500,
            // fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
            fontSize: '16px',
            fontSmoothing: 'antialiased',

            '::placeholder': {
              color: '#CFD7DF',
            },
            ':-webkit-autofill': {
              color: '#e39f48',
            },
          },
          invalid: {
            color: '#E25950',

            '::placeholder': {
              color: '#FFCCA5',
            },
          },
        };

      var elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      };

      var style = {
        base: {
          color: "#32325d",
        }
      };
      let _this = this;
      if(this.cardElement==null){
        this.cardElement = this.elements.create('card', {
            style: elementStyles,
            classes: elementClasses,
          });
          this.cardElement.mount('#card-element');
          this.cardElement.on('change', function(event) {
            _this.complete = event.complete;
            if (event.complete) {
              _this.cardBrandName = event.brand;
            } else if (event.error) {
              _this.complete = false;
              // console.log(event.error);
            }
          });
         
      }
      this.paymentFormInitialized = true;
      } 
      
    },
    open(){
      this.getPortausCompany()
      .then((portausCompany) => {
        this.stripePK = _.get(portausCompany, 'stripePublicKey');
        this.initStripe();
        paymentAPI.createStripeCustomer(this.customerId);
      })
      
      this.step=0;
      this.amount=this.amountDue;
      this.paymentFormInitialized=false
      this.paymentToken=null;

    },
    setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    calculateAmountDueOnInvoice(invoice){
      return invoice.balance.outstanding;
    },
    getAmountPaid(invoice){
      let amountPaid = 0.00;
      _.forEach(invoice.payments, payment=>{
        amountPaid+=payment.invoice_payment.amount;
      })
      return amountPaid
    },
    getCardLogoUrL (card) {
      if (card.brand === 'visa') {
        return require('@/assets/images/visa.png');
      } else if (card.brand === 'mastercard') {
        return require('@/assets/images/mastercard.png');
      } else if (card.brand === 'amex') {
        return require('@/assets/images/amex.png');
      } else if (card.brand === 'paypal') {
        return require('@/assets/images/paypal.png');
      } 
      // else {
      //   return require('');
      // }
    },
    getCardNumber( card ) {
      return `**** **** **** ${card.last4}`;
    },
    initStripe() {
      
      this.getPaymentCard(this.customerId);
    },
    getPortausCompany() {
      return portausCompanyAPI.getPortausCompany(this.portausCompanyId)
        .then(_.head);
    },
	},
	computed: {
    cardBrandInfo(){
      if (this.selectedCard != null) {
        return _.get(this.selectedCard, 'card.brand');
      } else {
        return this.cardBrandName;
      }
    },
    cardNumberInfo(){
      if (this.selectedCard != null) {
        return this.selectedCard.card.last4;
      } else {
        return _.get(this.card, 'lastDigits');
      }
    },
    selectedCard () {
      if (this.paymentMethod != null && this.paymentMethod != '') {
        const selectedCard = this.paymentMethod;
        return _.find(this.paymentMethods, pm =>  pm.id === selectedCard);
      }
      return null;  
    },
    currency(){
      return this.invoices!=null && this.invoices.length>0 ? this.invoices[0].currency.code : '';
    },
    amountDue(){
      let amountDue = 0.00;
      _.forEach(this.invoices, invoice=>{
        amountDue+=this.calculateAmountDueOnInvoice(invoice);
      })
      return amountDue;
    },
	},
  mounted() {
   
	},
  created(){
    console.log('Created event');
    this.stripePK = process.env.VUE_APP_STRIPE_KEY;
    this.initStripe();

    // this.getPortausCompany()
    //   .then((portausCompany) => {
    //     console.log('stripePublicKey : ', _.get(portausCompany, 'stripePublicKey'));
    //     this.stripePK = _.get(portausCompany, 'stripePublicKey');
    //     this.initStripe();
    //   })
    // On va fetcher les informations des compagnies pour le systemID
  
  },
  beforeDestroy(){
    this.cancelWaitingPayment();
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables';

#cardNumber {
  margin-top:10px;
	height:40px;

	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.el-radio.is-bordered {
  height:60px;
}


#cardExpiry {
	margin-top:10px;
	height:40px;
	width:100px;
	border: 1px solid rgba(95, 143, 223, 0.2);
	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.image-logo {
  height:40px;
  margin-right: 10px;
  vertical-align:middle;
}

.card_method_number {
  font-size:16px;
  letter-spacing: 1px;
  vertical-align: middle;
}

#cardCVC {
	margin-top:10px;
	height:40px;
	width:70px;
	border: 1px solid rgba(95, 143, 223, 0.2);
	padding-left:5px;
	padding-right:5px;
  color:#5B6266;
  -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.credit-card-box .panel-title {
    display: inline;
    font-weight: bold;
}
.credit-card-box .form-control.error {
    border-color: red !important;
    outline: 0;
    // box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(255,0,0,0.6);
}
.credit-card-box label.error {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 2px;
}
.credit-card-box .payment-errors {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 12px;
}
.credit-card-box label {
    display: block;
}

.credit-card-box .display-tr {
    display: table-row;
}
.credit-card-box .display-td {
    display: table-cell;
    vertical-align: middle;
    width: 50%;
}

.credit-card-box .panel-heading img {
    min-width: 180px;
    border-style: solid;
    border-width: 3px;
    border-color: white;
    box-shadow: 3px 3px 5px #D3D3D3;
}

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}
.product{
  line-height:20px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}

.formContainer{
    margin-left:20%;
    width:60%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

.stripe {
  background-color: #fff;
}

.stripe * {
  // font-family: Source Code Pro, Consolas, Menlo, monospace;
  font-size: 16px;
  font-weight: 500;
}

.stripe .row {
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px 10px;
}

.stripe .field {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 10px;
}

.stripe .field.half-width {
  width: 50%;
}

.stripe .field.quarter-width {
  width: calc(25% - 10px);
}

.stripe .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  pointer-events: none;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
}

.stripe .input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.stripe .input.focused,
.stripe .input:not(.empty) {
  opacity: 1;
}

.stripe .input.focused::-webkit-input-placeholder,
.stripe .input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused::-moz-placeholder,
.stripe .input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.stripe .input.focused:-ms-input-placeholder,
.stripe .input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused + label,
.stripe .input:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.stripe .input.focused + label {
  color: #5f8fdf;
}

.stripe .input.invalid + label {
  color: #ffa27b;
}

.stripe .input.focused + label + .baseline {
  background-color: #5f8fdf;
}

.stripe .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.stripe input, .stripe button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

.stripe input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.stripe .StripeElement--webkit-autofill {
  background: transparent !important;
}

.stripe input, .stripe button {
  -webkit-animation: 1ms void-animation-out;
}

.stripe button {
  display: block;
  width: calc(100% - 30px);
  height: 40px;
  margin: 40px 15px 0;
  background-color: #24b47e;
  border-radius: 4px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
}

.stripe .error svg {
  margin-top: 0 !important;
}

.stripe .error svg .base {
  fill: #e25950;
}

.stripe .error svg .glyph {
  fill: #fff;
}

.stripe .error .message {
  color: #e25950;
}

.stripe .success .icon .border {
  stroke: #abe9d2;
}

.stripe .success .icon .checkmark {
  stroke: #24b47e;
}

.stripe .success .title {
  color: #32325d;
  font-size: 16px !important;
}

.stripe .success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.stripe .success .reset path {
  fill: #24b47e;
}

</style>
